export default __webpack_public_path__ + "images/640cdae1d70f71d5ccc89fe987bfdeb2-mormonism.jpg";